import { Component, type ErrorInfo, type ReactNode } from 'react'

import { AppErrorView } from '../ui/AppErrorView'
import {
  isStaleAssetError,
  requestRequiredAppUpdate,
} from './app-update-required'

type AppCrashBoundaryProps = {
  children: ReactNode
}

type AppCrashBoundaryState = {
  failure: 'application' | 'stale-assets' | null
}

export class AppCrashBoundary extends Component<
  AppCrashBoundaryProps,
  AppCrashBoundaryState
> {
  state: AppCrashBoundaryState = { failure: null }

  static getDerivedStateFromError(error: unknown): AppCrashBoundaryState {
    return {
      failure: isStaleAssetError(error) ? 'stale-assets' : 'application',
    }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (isStaleAssetError(error)) {
      requestRequiredAppUpdate()
      return
    }

    console.error('Uncaught application error', error, info)
  }

  render() {
    if (this.state.failure === 'stale-assets') return null

    if (this.state.failure === 'application') {
      return (
        <AppErrorView
          actionLabel="Обновить страницу"
          title="CardReplay временно недоступен"
          description="Обновите страницу. Если ошибка повторится, текущие данные останутся на сервере."
          onAction={() => window.location.reload()}
        />
      )
    }

    return this.props.children
  }
}
